import { render, staticRenderFns } from "./GridPreRollExp.vue?vue&type=template&id=0541a35e&scoped=true"
import script from "./GridPreRollExp.vue?vue&type=script&setup=true&lang=ts"
export * from "./GridPreRollExp.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./GridPreRollExp.vue?vue&type=style&index=0&id=0541a35e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0541a35e",
  null
  
)

export default component.exports